export const userConstants = {
  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  SSO_LOGIN_REQUEST: 'SSO_USERS_LOGIN_REQUEST',
  SSO_LOGIN_SUCCESS: 'SSO_USERS_LOGIN_SUCCESS',
  SSO_LOGIN_FAILURE: 'SSO_USERS_LOGIN_FAILURE',

  UPDATE_EMAIL_REQUEST: 'USERS_UPDATE_EMAIL_REQUEST',
  UPDATE_EMAIL_SUCCESS: 'USERS_UPDATE_EMAIL_SUCCESS',
  UPDATE_EMAIL_FAILURE: 'USERS_UPDATE_EMAIL_FAILURE',

  CHANGE_PASSWORD: 'USERS_CHANGE_PASSWORD',
  RESET_PASSWORD: 'USERS_RESET_PASSWORD',

  LOGOUT: 'USERS_LOGOUT',

  GETALL_REQUEST: 'USERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'USERS_GETALL_FAILURE',

  GET_REQUEST: 'USER_GET_REQUEST',
  GET_SUCCESS: 'USER_GET_SUCCESS',
  GET_FAILURE: 'USER_GET_FAILURE',

  SET_PRACTITIONER_PRODUCT_SUB: 'SET_PRACTITIONER_PRODUCT_SUB',

  DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'USERS_DELETE_FAILURE',
};
